export default {
  listeners: {},
  register(target, event, callback, namespace = 'default') {
    if (!this.listeners[namespace]) this.listeners[namespace] = [];
    if (target._isVue) {
      return this.registerVueListener(target, event, callback, namespace);
    } else {
      return this.registerDomListener(target, event, callback, namespace);
    }
  },
  registerVueListener(target, event, callback, namespace) {
    target.$on(event, callback);
    const listener = {
      deregister() {
        target.$off(event, callback);
        () => this.removeFromListenerRegistry(listener, namespace);
      }
    };
    this.listeners[namespace].push(listener);
    return listener;
  },
  removeFromListenerRegistry(listener, namespace) {
    this.listeners[namespace] = this.listeners[namespace].filter(
      listenerObject => listenerObject !== listener
    );
  },
  registerDomListener(target, event, callback, namespace) {
    target.addEventListener(event, callback);
    const listener = {
      deregister() {
        target.removeEventListener(event, callback);
        () => this.removeFromListenerRegistry(listener, namespace);
      }
    };
    this.listeners[namespace].push(listener);
    return listener;
  },
  removeListeners(namespace) {
    if (!this.listeners[namespace]) {
      return;
    }
    this.listeners[namespace].forEach(listener => {
      listener.deregister();
    });
  }
};
